import { render, staticRenderFns } from "./OrdersMenu.vue?vue&type=template&id=c2dd9718"
import script from "./OrdersMenu.vue?vue&type=script&lang=js"
export * from "./OrdersMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports